/* Wholesale Inquiry 2.2.0: short 3-step application sent straight to Marketing Studio, hobby-grower screen, shortcut buttons, mobile Apply bar, lead tracking. */
(() => {
  const root = document.getElementById('GLLFWholesalePortal');
  if (!root || root.dataset.wpUp === '1') return;
  root.dataset.wpUp = '1';
  const form = document.getElementById('GLLFPremiumWholesaleForm');
  const area = document.getElementById('WholesaleApplication');
  const bar = root.querySelector('[data-wp-bar]');
  const push = (name, d = {}) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, form_name: 'GLLF Wholesale Inquiry', ...d }); };
  const toForm = () => { if (area) area.scrollIntoView({ behavior: 'smooth', block: 'start' }); };

  /* Google Ads: count one wholesale lead after a successful send */
  const ID = 'AW-11135645635', SEND = ID + '/IbmkCIv-hqkYEMPv8b0p';
  try {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const s = document.createElement('script'); s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + ID;
      document.head.appendChild(s); window.gtag('js', new Date());
    }
    window.gtag('config', ID);
  } catch (e) {}
  const success = root.querySelector('.wp-success');
  if (success) {
    if (bar) bar.remove();
    setTimeout(() => { success.scrollIntoView({ block: 'center' }); success.focus({ preventScroll: true }); }, 300);
    try {
      if (!sessionStorage.getItem('gllf_inquiry_counted')) {
        sessionStorage.setItem('gllf_inquiry_counted', '1');
        window.gtag('event', 'conversion', { send_to: SEND, value: 1.0, currency: 'USD' });
        push('wholesale_lead');
      }
    } catch (e) {}
  }

  /* keep the ad details with the inquiry */
  if (form) {
    const params = new URLSearchParams(location.search);
    form.querySelectorAll('[data-wp-param]').forEach((input) => {
      const key = input.dataset.wpParam; let stored = '';
      try { stored = sessionStorage.getItem('gllf_' + key) || ''; } catch (e) {}
      const value = params.get(key) || stored;
      if (value) { input.value = value; try { sessionStorage.setItem('gllf_' + key, value); } catch (e) {} }
    });
  }

  /* 3 steps */
  const steps = form ? [...form.querySelectorAll('[data-wp-step]')] : [];
  if (form && steps.length) {
    root.classList.add('wp-js');
    form.noValidate = true;
    const next = form.querySelector('[data-wp-next]'), back = form.querySelector('[data-wp-back]'), submit = form.querySelector('[data-wp-submit]');
    const items = [...root.querySelectorAll('.wp-progress-item')];
    let current = 0;
    const clear = (scope) => { scope.querySelectorAll('.wp-field-error').forEach((e) => e.remove()); scope.querySelectorAll('.is-invalid').forEach((e) => e.classList.remove('is-invalid')); };
    const flag = (field) => {
      const holder = field.closest('.wp-confirm') || field.parentElement;
      holder.classList.add('is-invalid');
      const p = document.createElement('p'); p.className = 'wp-field-error'; p.setAttribute('role', 'alert');
      p.textContent = field.type === 'checkbox' ? 'Please confirm this item.' : field.validity.typeMismatch ? 'Please enter a valid email address.' : field.tagName === 'SELECT' ? 'Please choose one option.' : 'Please complete this field.';
      holder.appendChild(p);
    };
    const firstBad = (scope) => [...scope.querySelectorAll('input,select,textarea')].find((f) => f.willValidate && !f.checkValidity());
    const check = (i) => { clear(steps[i]); const bad = firstBad(steps[i]); if (!bad) return true; flag(bad); bad.focus(); return false; };
    const render = (move) => {
      steps.forEach((s, i) => s.classList.toggle('is-active', i === current));
      items.forEach((it, i) => { it.classList.toggle('active', i === current); it.classList.toggle('done', i < current); });
      back.hidden = current === 0; next.hidden = current === steps.length - 1; submit.hidden = current !== steps.length - 1;
      if (move) { toForm(); const f = steps[current].querySelector('input:not([type=hidden]),select,textarea'); if (f) setTimeout(() => f.focus({ preventScroll: true }), 350); }
    };
    /* 2.1.0: hobby and home growers don't need an account. Show them how to start shopping instead of the form. */
    const hobby = root.querySelector('[data-wp-hobby]'), type = form.querySelector('[data-wp-type]');
    const isHobby = () => !!(type && type.selectedOptions[0] && type.selectedOptions[0].hasAttribute('data-wp-hobby-choice'));
    const openHobby = (from) => {
      if (!hobby) return;
      form.hidden = true; hobby.hidden = false; push('wholesale_hobby_shown', { from });
      hobby.scrollIntoView({ behavior: 'smooth', block: 'center' }); hobby.focus({ preventScroll: true });
    };
    const closeHobby = () => { if (!hobby) return; hobby.hidden = true; form.hidden = false; if (type && isHobby()) type.value = ''; current = 0; render(true); };
    if (type) type.addEventListener('change', () => { if (isHobby()) openHobby('business_type'); });
    root.querySelectorAll('[data-wp-hobby-open]').forEach((b) => b.addEventListener('click', () => openHobby('last_step')));
    root.querySelectorAll('[data-wp-hobby-close]').forEach((b) => b.addEventListener('click', closeHobby));
    root.querySelectorAll('[data-wp-hobby-shop]').forEach((a) => a.addEventListener('click', () => push('wholesale_cta_click', { cta: 'hobby_shop_' + a.dataset.wpHobbyShop })));
    next.addEventListener('click', () => { if (current === 0 && isHobby()) { openHobby('business_type'); return; } if (!check(current)) return; push('wholesale_form_step', { step: current + 1 }); current = Math.min(current + 1, steps.length - 1); render(true); });
    back.addEventListener('click', () => { current = Math.max(current - 1, 0); render(true); });
    form.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && current < steps.length - 1) { e.preventDefault(); next.click(); } });
    /* runs before the page's own submit handler: every step must be complete */
    form.addEventListener('submit', (e) => {
      if (isHobby()) { e.preventDefault(); e.stopImmediatePropagation(); openHobby('submit'); return; }
      for (let i = 0; i < steps.length; i++) {
        if (firstBad(steps[i])) { e.preventDefault(); e.stopImmediatePropagation(); current = i; render(false); check(i); return; }
      }
      submit.disabled = true; submit.textContent = 'Sending…';
    }, true);
    /* 2.2.0: the application is sent straight to Marketing Studio (gllf-form-guard.js). It reports back here, and
       this shows what really happened: access on, received for review, or something to fix. */
    const mk = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
    const countLead = () => { try { if (!sessionStorage.getItem('gllf_inquiry_counted')) { sessionStorage.setItem('gllf_inquiry_counted', '1'); window.gtag('event', 'conversion', { send_to: SEND, value: 1.0, currency: 'USD' }); push('wholesale_lead'); } } catch (e) {} };
    const showResult = (d) => {
      root.querySelectorAll('.wp-done').forEach((n) => n.remove());
      const box = mk('div', 'wp-success wp-done'); box.tabIndex = -1; box.setAttribute('role', 'status');
      if (d.state === 'access') {
        box.appendChild(mk('strong', '', d.already ? '💜 You already have wholesale access.' : '💜 You’re in. Wholesale access is on.'));
        const p = mk('p'); p.append('Sign in with ', mk('b', '', d.email || 'the email you entered'), '. We send a one-time code, so there is no password to remember. Then come back to this page for your Trade Desk.'); box.appendChild(p);
        const row = mk('div', 'wp-hobby-actions'); const a1 = mk('a', 'wp-btn wp-primary', 'Sign in'); a1.href = '/account'; const a2 = mk('a', 'wp-btn wp-secondary', 'Open the Trade Desk'); a2.href = '/pages/wholesale'; row.append(a1, a2); box.appendChild(row);
        if (d.welcomed) box.appendChild(mk('p', '', 'A welcome email with these steps is on its way.'));
      } else {
        box.appendChild(mk('strong', '', '💜 Thank you. We received your application.'));
        box.appendChild(mk('p', '', 'Wholesale access was not turned on automatically, so our farm team will review it and email you.'));
      }
      form.hidden = true; form.parentElement.insertBefore(box, form); if (bar) bar.remove();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' }); box.focus({ preventScroll: true });
    };
    form.addEventListener('gllf:application', (event) => {
      const d = event.detail || {};
      form.querySelectorAll('.wp-form-fix').forEach((n) => n.remove());
      if (d.state === 'sending') { submit.disabled = true; submit.dataset.label = submit.dataset.label || submit.textContent; submit.textContent = 'Sending…'; }
      else if (d.state === 'fix') { submit.disabled = false; submit.textContent = submit.dataset.label || 'Apply for Wholesale Access'; const p = mk('p', 'wp-field-error wp-form-fix', d.message || 'Please check the form and try again.'); p.setAttribute('role', 'alert'); submit.parentElement.parentElement.insertBefore(p, submit.parentElement); }
      else if (d.state === 'access' || d.state === 'received') { countLead(); showResult(d); }
    });
    form.addEventListener('input', (e) => { const h = e.target.closest('.is-invalid'); if (h && e.target.checkValidity()) { h.classList.remove('is-invalid'); h.querySelectorAll('.wp-field-error').forEach((x) => x.remove()); } });
    render(false);
  }

  /* backup path (Shopify's own form): the page says "we received it"; if access is then confirmed, say so */
  document.addEventListener('gllf:form-recorded', (event) => {
    const d = event.detail || {}, got = root.querySelector('[data-gllf-received]');
    if (d.form !== 'wholesale-inquiry' || !d.access || !got) return;
    got.querySelector('strong').textContent = '💜 You’re in. Wholesale access is on.';
    const p = document.createElement('p'); p.textContent = 'Sign in with the email you entered. We send a one-time code, so there is no password to remember. Then come back to this page for your Trade Desk.'; got.appendChild(p);
  });

  /* shortcut buttons: tick the matching interest and go to the application */
  root.querySelectorAll('[data-wp-interest]').forEach((btn) => btn.addEventListener('click', () => {
    const box = form && form.querySelector('input[name="contact[' + btn.dataset.wpInterest + ']"]');
    if (box) box.checked = true;
    push('wholesale_cta_click', { cta: btn.dataset.wpInterest });
    toForm();
  }));
  root.querySelectorAll('[data-wholesale-apply-2]').forEach((b) => b.addEventListener('click', () => { push('wholesale_cta_click', { cta: 'mobile_bar' }); toForm(); }));

  /* mobile Apply bar steps aside while the application is on screen */
  if (bar && area && 'IntersectionObserver' in window) {
    new IntersectionObserver((en) => bar.classList.toggle('is-off', en[0].isIntersecting), { rootMargin: '0px 0px -30% 0px' }).observe(area);
  }
})();

/* keep floating helpers (chat bubble, hCaptcha badge) clear of the mobile Apply bar and of each other */
(() => {
  const ROOT = '#GLLFWholesalePortal';
  if (!document.querySelector(ROOT)) return;
  const GAP = 10, MARK = 'data-gllf-lift';
  const isFloat = (el) => {
    if (el.nodeType !== 1 || el.closest(ROOT) || /^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return false;
    const s = getComputedStyle(el);
    return s.position === 'fixed' && s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > 0.05;
  };
  const floats = () => {
    const out = [], walk = (node, depth) => {
      for (const el of node.children) {
        if (el.matches('header,footer,main,#MainContent,.shopify-section,[id^="shopify-section"]') && !isFloat(el)) { if (depth < 2) continue; }
        if (isFloat(el)) { out.push(el); continue; }
        if (depth < 4) walk(el, depth + 1);
      }
    };
    walk(document.body, 0);
    return out;
  };
  let busy = false;
  const arrange = () => {
    if (busy) return; busy = true;
    try {
      const bar = document.querySelector(ROOT + ' .wp-mobile-cta');
      const on = bar && getComputedStyle(bar).display !== 'none' && !bar.classList.contains('is-off');
      const barH = on ? Math.round(bar.getBoundingClientRect().height) : 0;
      const vw = innerWidth, vh = innerHeight, placed = [];
      const list = floats().map((el) => { el.style.translate = ''; el.removeAttribute(MARK); return el; })
        .map((el) => ({ el, r: el.getBoundingClientRect() }))
        .filter(({ r }) => r.width > 8 && r.height > 8 && r.bottom > vh - 260 && r.top < vh && r.height < vh * 0.45 && r.width < vw * 0.92)
        .sort((a, b) => b.r.bottom - a.r.bottom || b.r.right - a.r.right);
      for (const { el, r } of list) {
        let bottom = Math.min(r.bottom, vh - barH - (barH ? GAP : 0));
        for (let pass = 0; pass < 6; pass++) {
          const hit = placed.find((p) => r.left < p.right + GAP && r.right > p.left - GAP && bottom > p.top - GAP && bottom - r.height < p.bottom + GAP);
          if (!hit) break; bottom = hit.top - GAP;
        }
        const shift = Math.round(r.bottom - bottom);
        if (shift > 0 && bottom - r.height > 60) { el.style.translate = `0 ${-shift}px`; el.setAttribute(MARK, shift); }
        const top = (shift > 0 ? bottom : r.bottom) - r.height;
        placed.push({ left: r.left, right: r.right, top, bottom: top + r.height });
      }
    } catch (e) {}
    setTimeout(() => { busy = false; }, 0);
  };
  let timer; const soon = () => { clearTimeout(timer); timer = setTimeout(arrange, 150); };
  [0, 800, 2000, 4000, 8000].forEach((ms) => setTimeout(arrange, ms));
  addEventListener('resize', soon); addEventListener('orientationchange', soon); addEventListener('load', soon);
  new MutationObserver(() => { if (!busy) soon(); })
    .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
})();
